// ======================================================================
// File Name       : ContentQuestionSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { DATA_AFFIILIATION_TYPE_STR, CONTENT_QUESTION_KIND } from '../../constants/ContentConstant';
import PaginationCustom from '../Pagination';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import AttributeQuestion from './AttributeQuestion';
import CustomButton from '../button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import * as FUNCTION from '../../constants/FunctionConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';

const ContentQuestionSearch = (props) => {
  const {
    questionSecernId,
    questionTitle,
    answerFormula,
    convertStatus,
    questionKind,
    dataAffiliationType,
    onInputChange,
    onSearchBtnClick,
    openExportDialog,
    openOrCloseAttributeArea,
    isClosed,
    handleChangeOption,
    formValues,
    attributeOptions,
    attributeText,
    attributeListData,
    buttonText,
    openPreviewEachQuestionAttribute,
    addAttribute,
    number,
    removeAttributeSearch,
    createdUserName, // Step 9.0.0
  } = props;
  const canAccessRegister = canAccessRoute(FUNCTION.CONTENT_QUESTION_REGISTER);
  const canAccessImport = canAccessRoute(FUNCTION.CONTENT_QUESTION_IMPORT);

  return (
    <Col sm={12} className="padding-left-right-clear">
      <h3>検索する項目を指定してください</h3>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          onSearchBtnClick();
        }}
        className='form-horizontal'
      >
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              問題識別ID
            </Col>
            <Col sm={7}>
              <RenderField type="text" name="questionSecernId" label="問題識別ID" value={questionSecernId} />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              問題タイトル
            </Col>
            <Col sm={7}>
              <RenderField type="text" name="questionTitle" value={questionTitle} />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              解答方式
            </Col>
            <Col sm={7}>
              <RenderField data={SELECT_BOX_DATA.ANSWER_FORMULA_WITH_NULL} name="answerFormula" type="selectbox" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              変換ステータス
            </Col>
            <Col sm={7}>
              <RenderField data={SELECT_BOX_DATA.CONVERT_STATUS_WITH_NULL} name="convertStatus" type="selectbox" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              登録日
            </Col>
            <Col sm={3}>
              <RenderField
                type="datetime"
                name="createdDateFrom"
                validates={[VALIDATE_TYPE.DATE_TIME]}
                normalizeDateTime
              />
            </Col>
            <Col sm={1} className="text-center" as={Form.Label}>
              ～
            </Col>
            <Col sm={3}>
              <RenderField
                type="datetime"
                name="createdDateTo"
                validates={[VALIDATE_TYPE.DATE_TIME]}
                normalizeDateTime
              />
            </Col>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'createdDateFrom'}
                keyDateTo={'createdDateTo'}
              />
            </Col>
          </Form.Group>
          {/* Step 9.0.0 START */}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              登録者
            </Col>
            <Col sm={7}>
              <RenderField type="text" name="createdUserName" value={createdUserName} maxLength={40} />
            </Col>
          </Form.Group>
          {/* Step 9.0.0 END */}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              自サービス/外部
            </Col>
            <Col sm={9} className="padding-top-10">
              <RenderField
                className="padding-top-clear"
                name="dataAffiliationType"
                value={DATA_AFFIILIATION_TYPE_STR.NOT_SELECT}
                type="radio"
                label="選択なし"
              />
              <RenderField
                className="margin-left-15 padding-top-clear"
                name="dataAffiliationType"
                value={DATA_AFFIILIATION_TYPE_STR.INTERNAL}
                type="radio"
                label="自サービスコンテンツ"
              />
              <RenderField
                className="margin-left-15 padding-top-clear"
                name="dataAffiliationType"
                value={DATA_AFFIILIATION_TYPE_STR.EXTERNAL}
                type="radio"
                label="外部コンテンツ"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              単問/大問
            </Col>
            <Col sm={9} className="padding-top-10">
              <RenderField
                className="padding-top-clear"
                name="questionKind"
                value={CONTENT_QUESTION_KIND.NO_TYPE}
                type="radio"
                label="選択なし"
              />
              <RenderField
                className="margin-left-15 padding-top-clear"
                name="questionKind"
                type="radio"
                value={CONTENT_QUESTION_KIND.SINGLE_QUESTION}
                label="単問"
              />
              <RenderField
                className="margin-left-15 padding-top-clear"
                name="questionKind"
                type="radio"
                value={CONTENT_QUESTION_KIND.BIG_QUESTION}
                label="大問"
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-20">
            <Col sm={3} as={Form.Label} className="padding-left-5">
              <a role="presentation" className={buttonText} onClick={openOrCloseAttributeArea}>
              問題属性
              </a>
            </Col>
          </Form.Group>
          {!isClosed &&
            <AttributeQuestion
              keyOptions="attributeOptions"
              keyText="attributeText"
              keyDelete="attributeDelete"
              openOrCloseAttributeArea={openOrCloseAttributeArea}
              isClosed={isClosed}
              handleChangeOption={handleChangeOption}
              formValues={formValues}
              attributeOptions={attributeOptions}
              attributeText={attributeText}
              attributeListData={attributeListData}
              buttonText={buttonText}
              addAttribute={addAttribute}
              number={number}
              removeAttributeSearch={removeAttributeSearch}
            />
          }
        </Col>
        <Form.Group className="margin-top-20 text-center">
          <Col sm={12} className="text-center margin-top-20">
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              type="submit"
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
        </Form.Group>
        <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="padding-left-right-clear">
              <Col Col sm={9} className="inline-flex margin-bottom-10 margin-top-10">
                {canAccessRegister && (
                  <CustomLink
                    className="margin-right-7 btn-register margin-right-10"
                    to={Path.CONTENT_QUESTION_REGISTER}
                    text="問題追加"
                    icon={ICON.REGIST}
                  />
                )}
                {canAccessImport && (
                  <CustomLink
                    className="margin-right-7 btn-csv-import"
                    to={Path.CONTENT_QUESTION_IMPORT}
                    text="CSV一括投入"
                    icon={ICON.IMPORT}
                  />
                )}
              </Col>
              <Col sm={3}>
              <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={openExportDialog}
                  iconClass="bi bi-download"
                  text="一括出力"
                />
              </Col>
            </Col>
          </Form.Group>
      </Form>
    </Col>
  );
};

export default ContentQuestionSearch;
